import { observer } from 'mobx-react-lite';
import useIsHalfScreenMap from '../../hooks/useIsHalfScreenMap';
import commonStyles from '../Common.module.css';
import styles from './OnMapSpinner.module.css';
import Spinner from './Spinner';

function FullScreenSpinner() {
    const isHalfScreenMap = useIsHalfScreenMap();

    return (
        <div className={[
            isHalfScreenMap ? commonStyles.halfWidthOnMapPanel : commonStyles.onMapPanel,
            styles.container,
        ].join(" ")}>
            <Spinner />
        </div>
    );
}

export default observer(FullScreenSpinner);